import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { TranslationService } from 'src/app/services/translation.service';
import { ApiService } from 'src/app/services/api.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-new-goal',
  templateUrl: './new-goal.component.html',
  styleUrls: ['./new-goal.component.css']
})
export class NewGoalComponent implements OnInit {
  @Input() open: Boolean;
  @Input() cat: String;
  @Output() close = new EventEmitter<boolean>();
  categories: Array<any> = [];
  categoriesMap: Array<any> = [];
  invalid: Boolean = false;
  goals: Array<any> = [];
  useSuggested = '';
  profileForm = new FormGroup({
    title: new FormControl('', [Validators.required]),
    description: new FormControl('', [Validators.required]),
    outcomes: new FormControl([]),
    category: new FormControl(null, [Validators.required])
  });
  constructor(
    public translations: TranslationService,
    private apiservice: ApiService
  ) { }

  ngOnInit() {
    this.getData();
  }

  getData() {
    if (this.apiservice.user.profiles) {
      this.apiservice.getProfileById(this.apiservice.user.profiles._id, this.apiservice.user._id, true).subscribe((res: any) => {
        this.categories = res.data.categoryMap.map(cat => {
          cat['category']['goals'] = cat['goals'];
          return cat;
        });
        this.categories.sort(function(a, b) {
          return a.rank - b.rank;
        });
        if (this.cat) {
          this.profileForm.patchValue({ category: this.cat });
          let index = this.categories.findIndex(data => data.category._id == this.cat);
          this.goals = this.categories[index]['category']['goals'];
        }
      })
    } else {
      this.apiservice.getCreatedCategories(this.apiservice.user._id, 'all').subscribe((res: any) => {
        this.categories = res.data.map(cat => {
          cat['category'] = cat;
          return cat;
        });
        if (this.cat) {
          this.profileForm.patchValue({ category: this.cat });
          let index = this.categories.findIndex(data => data.category._id == this.cat);
          this.goals = this.categories[index]['category']['goals'];
        }
      });
    }
    // }
  }

  ngOnChanges(changes) {
    this.getData();
  }

  setGoals(event) {
    let index = this.categories.findIndex(data => data.category._id == event.target.value);
    this.goals = this.categories[index]['category']['goals'];
  }

  selectEvent(item) {
    this.useSuggested = item._id;
    this.profileForm.patchValue({ title: item.title });
  }

  onChangeSearch(search: string) {
    this.profileForm.patchValue({ title: search });
  }

  submit() {
    this.invalid = false;
    if (!this.profileForm.valid) {
      this.invalid = true;
      return;
    }
    let formData = new FormData();
    formData.append('title', this.profileForm.get('title').value);
    formData.append('description', this.profileForm.get('description').value);
    formData.append('category', this.profileForm.get('category').value);
    if (this.apiservice.user.profiles) {
      let index: any = this.categories.findIndex(data => data.category._id == this.profileForm.get('category').value);
      index = this.categories[index]._id;
      formData.append('categoryMap', index);
    }
    if (this.useSuggested) {
      formData.append('useSuggested', this.useSuggested);
    }
    formData.append('createdBy', this.apiservice.user._id);
    formData.append('outcomes', JSON.stringify(this.profileForm.get('outcomes').value));
    this.apiservice.creatNewGoal(formData).subscribe((res: any) => {
      this.useSuggested = '';
      this.close.emit(true);
    });
  }

}
